import { FileReader, FileWriter } from '@/platform'

class FileItemBuf {
    // 文件名（相对路径）
    public name: string = ''
    // 文件内容二进制
    public content: Uint8Array = new Uint8Array(0)

    constructor(name: string = '', content: Uint8Array = new Uint8Array(0)) {
        this.name = name
        this.content = content
    }

    readData(reader: FileReader): void {
        this.name = reader.readString()
        this.content = reader.readSome(reader.readInt())
    }

    writeData(writer: FileWriter): void {
        writer.writerIntLength()
        writer.writeString(this.name)
        writer.writeInt(this.content.length)
        writer.writeBytes(this.content)
        writer.writerLength()
    }
}

export default FileItemBuf
